export class SimpAt {
    constructor() {}
    commonStep = 'stepper.form.commun.SIMP.step';
    step = 'stepper.form.simp_at.step';
    
  }
